import { render } from "./Header.vue?vue&type=template&id=48505dbf&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=48505dbf&scoped=true&lang=css"

import exportComponent from "/data0/www.sxsmdx.cn/src/ui/src-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48505dbf"]])

export default __exports__